import bgPng from '../assets/images/bg.png';
import bg1Png from '../assets/images/bg1.png';
import companyBgPng from '../assets/images/companyBg.png';
import styles from './AboutCompany.module.scss';
import u175Png from '../assets/images/u175.png'
import u176Png from '../assets/images/u176.png'
import { getLangName as t } from '../utils/index'
function AboutComyany() {
    return <>
        <div className={styles.AboutComyany}>
            <div className={styles.bg}>
                <div className={styles.bgTxt}>
                    <span className={styles.bgTxtCn}>关于我们</span>
                    <span className={styles.bgTxtEn}>About Us</span>
                </div>
                <img src={bgPng} alt="" />
            </div>
            <div className={styles.company}>
                <div className={styles.company_left}>
                    <div className={styles.company_left_title}>
                        公司介绍
                    </div>
                    <div className={styles.company_left_txt}>
                        ABOUT US
                    </div>
                    <div className={styles.company_left_cont}>
                    深圳市绿电智行科技有限公司成立于2023年12月19日，注册地位于深圳市龙华区福城街道桔塘社区溢佳路6号溢佳工业园。经营范围包括电池销售；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；储能技术服务；电子专用材料研发；电子元器件与机电组件设备销售；半导体器件专用设备销售；蓄电池租赁；通讯设备销售；货物进出口；国内贸易代理；互联网销售；软件开发。
                   </div>
                </div>
                <div className={styles.company_right}>
                    <img src={companyBgPng} alt="" />
                </div>
            </div>
            <div className={styles.bg1}>
                <img src={bg1Png} alt="" />
            </div>
            <div className={styles.companyInfo}>
                <div className={styles.companyInfo_title}>为什么选择我们？</div>
                <div className={styles.companyInfo_txt}>WHY CHOOSE US?</div>
                <div className={styles.companyInfo_content}>
                    <div className={styles.companyInfo_content_item}>
                        <img src={u175Png} />
                        <div className={styles.companyInfo_content_item_title}>{t('ProfessionalStrength')}</div>
                        <div className={styles.companyInfo_content_item_txt}>
                            {t('ProfessionalStrengthContent')
                            }</div>
                    </div>
                    <div className={styles.companyInfo_content_item}>
                        <img src={u176Png} />
                        <div className={styles.companyInfo_content_item_title}>{t('GoodService')}</div>
                        <div className={styles.companyInfo_content_item_txt}>
                            {t('GoodServiceContent')
                            }</div>
                    </div>
                    <div className={styles.companyInfo_content_item}>
                        <img src={u176Png} />
                        <div className={styles.companyInfo_content_item_title}>{t('CoreValues')}</div>
                        <div className={styles.companyInfo_content_item_txt}>
                            {t('CoreValuesContent')
                            }</div>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default AboutComyany;